import { extractCurrentFolderTranslations } from '../utils';

export default extractCurrentFolderTranslations(import.meta.glob('./*.ts', { eager: true }));
